export default {
  empty: 'Veuillez renseigner ce champ',
  email: 'Le format de l\'email incorrect',
  password: 'Votre mot de passe doit respecter au moins 4 des 5 conditions suivantes : contenir un/'
            + ' une minuscule, majuscule, symbole, chiffre ou avoir plus de 8 caractères.',
  passwordConfirm: 'Les champs Mot de passe et Confirmation du mot de passe doivent avoir la même'
                   + ' valeur'
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/config/errorMessages.js